import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaAngleUp, FaAngleDown } from "react-icons/fa6"; 
import Navbar from "../../components/Navbar";
import ListadoRecursos from "../../components/carrusel/UserRecursosDestacados";
import "./css/Empleo.css";

const Recursos = () => {

  //Para que el botón Recursos de las páginas Empleo, Formación y Social redirija a esta página con la opcion del desplegable seleccionada
  const location = useLocation();
  const initialCategoria = location.state?.categoria || "destacadas";
  const [categoria, setCategoria] = useState(initialCategoria);

  // Estados para manejar el desplegable Mapa
    const [showMapa, setShowMapa] = useState(false);

  return (
    <>
        <Navbar />
        
        <main className="main-user empleo-formacion column">

          {/* Desplegable con Iframe de Mapa */}
          <div className="desplegable">
            <div className="titulo-desplegable between cursor" onClick={() => setShowMapa(!showMapa)} >
              <h2 className="mayusculas">MAPA DE los RECURSos locales</h2>
              <span>{showMapa ? <FaAngleUp /> : <FaAngleDown />}</span>
            </div>
            {showMapa && (
              <div className="desplegable-contenido">
                <iframe 
                  src="https://www.google.com/maps/d/embed?mid=19F2_7tB9wlFmI6Yv7C-j_xkT2IBaErJ7&hl=es&ehbc=2E312F" width="100%" height="480">
                </iframe>
              </div>
            )}
          </div>

          
          
          <section id="recursos" className="between mt-50">
            <h1 className="titulo-user align-center">
              <span className="titulo-user align-center gap-10">
                RECURSOS DE INTERÉS 
                <select
                  aria-label="Filtrados por"
                  className="desplegable-empleo mayusculas" 
                  value={categoria} 
                  onChange={(e) => setCategoria(e.target.value)}
                >
                  <option value="destacadas">DESTACADOS</option>
                  <option value="empleo">sobre empleo</option>
                  <option value="formacion">sobre formación</option>
                  <option value="social">social</option>
                  <option value="otros">otros</option>
                  <option value="todas">TODOS</option>
                </select>
              </span>
            </h1>
          </section>

          <ListadoRecursos categoria={categoria} />

        </main>
    </>
  );
};

export default Recursos;